import classnames from 'classnames'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './MenuBar.module.scss'
import { useIsMobile } from 'hooks/useIsMobile'


export type DataType = {
    id: number,
    title: string,
    value: string,
    link: string,
}

type Props = {
    data: DataType[],
}

export function MenuBar(props: Props) {
    let location = useLocation()
    const navigate = useNavigate()
    const { isMobile } = useIsMobile()

    function handleNavigate(link) {
        navigate(link)
    }

    if (isMobile) {
        return null
    }

    return (
        <div className={styles['menubar']}>
            {props.data.map((item) => {
                const itemClassName = classnames({
                    [styles['item']]: true,
                    [styles['item_active']]: location.pathname === item.link,
                })

                return (
                    <div className={itemClassName}
                        onClick={() => handleNavigate(item.link)}
                        key={item.id}
                    >
                        {item.title}
                    </div>
                )
            })}
        </div >
    );
}

